import { useState, useEffect, useCallback } from "react";

/**
 * Generic fetch hook.
 *
 * Usage:
 *   const { data, loading, error, refetch } = useApi("/clients/abc123/profile");
 *
 * BASE_URL is /api — matches the Flask blueprint prefix and Vite proxy rule.
 */

const BASE_URL = "/api";

export function useApi(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!path) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${BASE_URL}${path}`);
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || `HTTP ${res.status}`);
      }
      const json = await res.json();
      setData(json);
    } catch (err) {
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
